import React from "react";
import "./Card.css";

const CARD_IMAGE_URL = "/deck.png";

// Map card names to their position in the deck
const cardPositions = {
  "Eichel-Ass": { x: 0, y: 0 },
  "Eichel-König": { x: 1, y: 0 },
  "Eichel-Ober": { x: 2, y: 0 },
  "Eichel-Unter": { x: 3, y: 0 },
  "Eichel-10": { x: 4, y: 0 },
  "Eichel-9": { x: 5, y: 0 },
  "Eichel-8": { x: 6, y: 0 },
  "Eichel-7": { x: 7, y: 0 },
  "Grün-Ass": { x: 0, y: 1 },
  "Grün-König": { x: 1, y: 1 },
  "Grün-Ober": { x: 2, y: 1 },
  "Grün-Unter": { x: 3, y: 1 },
  "Grün-10": { x: 4, y: 1 },
  "Grün-9": { x: 5, y: 1 },
  "Grün-8": { x: 6, y: 1 },
  "Grün-7": { x: 7, y: 1 },
  "Herz-Ass": { x: 0, y: 2 },
  "Herz-König": { x: 1, y: 2 },
  "Herz-Ober": { x: 2, y: 2 },
  "Herz-Unter": { x: 3, y: 2 },
  "Herz-10": { x: 4, y: 2 },
  "Herz-9": { x: 5, y: 2 },
  "Herz-8": { x: 6, y: 2 },
  "Herz-7": { x: 7, y: 2 },
  "Schellen-Ass": { x: 0, y: 3 },
  "Schellen-König": { x: 1, y: 3 },
  "Schellen-Ober": { x: 2, y: 3 },
  "Schellen-Unter": { x: 3, y: 3 },
  "Schellen-10": { x: 4, y: 3 },
  "Schellen-9": { x: 5, y: 3 },
  "Schellen-8": { x: 6, y: 3 },
  "Schellen-7": { x: 7, y: 3 },
};

function Card({ cardName, isTrump, highlight=false }) {
  const cardPos = cardPositions[cardName];
  if (!cardPos) return <div>Invalid card: {cardName}</div>;

  const { x, y } = cardPos;
  const backgroundPosition = `-${x * 140}px -${y * 210}px`; // width * height of single card
  const randomDegree = Math.floor(Math.random() * 11) - 5; // -5° to +5°

  return (
    <div className="card-container" style={{ "--rotate-deg": `${randomDegree}deg` }}>
      <div
        className={`card ${isTrump && !highlight ? "trump" : ""} ${highlight ? "highlight" : ""}`}
        style={{
          backgroundImage: `url(${CARD_IMAGE_URL})`,
          backgroundPosition,
          transform: `rotate(${randomDegree}deg)`,
        }}
      ></div>
    </div>
  );
}

export default Card;